import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Settings from '../../../components/RightSidebar/Settings';

import {
  setCurrency,
  setOddsType
} from '@xanadu/ui-shared/modules/user/actions';

const getSelectedOddsType = (state) => {
  const selectedItem = state.getIn(['user', 'oddsType']);
  const item = state.getIn(['lookups', 'oddsTypes'])
    .find(value => selectedItem === value.id);
  return item ? item.id : '';
};

const getSelectedCurrency = (state) => {
  const selectedItem = state.getIn(['user', 'currency']);
  const item = state.getIn(['lookups', 'currencies'])
    .find(value => selectedItem === value.id);
  return item ? item.name : '';
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setCurrency,
    setOddsType,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    currency: getSelectedCurrency(state),
    oddsType: getSelectedOddsType(state),
    currencies: state.getIn(['lookups', 'currencies']),
    oddsTypes: state.getIn(['lookups', 'oddsTypes']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings));
